// @ is an alias to /src
import mastertime from '@/api/mastertime'

export const namespaced = true

export const state = {
  firmwares: [],
}

export const mutations = {
  setFirmwares(state, firmwares) {
    state.firmwares = firmwares
  },

  addFirmware(state, firmware) {
    state.firmwares.push(firmware)
  },

  editFirmware(state, firmware) {
    const index = state.firmwares.findIndex(
      (item) => item.firmware_uuid === firmware.firmware_uuid
    )
    if (index !== -1) {
      state.firmwares.splice(index, 1, firmware)
    }
  },

  deleteFirmware(state, firmware_uuid) {
    const index = state.firmwares.findIndex(
      (item) => item.firmware_uuid === firmware_uuid
    )
    if (index !== -1) {
      state.firmwares.splice(index, 1)
    }
  },
}

export const actions = {
  async fetchFirmwares({ commit }) {
    const { data } = await mastertime.fetchFirmwares()
    const firmwares = data.data

    commit('setFirmwares', firmwares)
  },

  async addFirmware({ commit }, payload) {
    const { data } = await mastertime.addFirmware(payload)
    const firmware = data

    commit('addFirmware', firmware)
  },

  async editFirmware({ commit }, payload) {
    const { data } = await mastertime.editFirmware(payload)
    const firmware = data

    commit('editFirmware', firmware)
  },

  async deleteFirmware({ commit }, payload) {
    await mastertime.deleteFirmware(payload)

    commit('deleteFirmware', payload.firmware_uuid)
  },
}
